// extracted by mini-css-extract-plugin
export default {"initialization-loader":"aXJk5T","initializationLoader":"aXJk5T","custom":"_JzuD3"};